"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConnectUser = void 0;
const react_1 = require("react");
const stream_chat_1 = require("stream-chat");
/**
 * A hook which handles the process of connecting/disconnecting a user
 * to the Stream Chat backend.
 *
 * @param apiKey the Stream app API key to use.
 * @param userToConnect the user information.
 * @param userTokenOrProvider the user's token.
 */
const useConnectUser = (userInfo) => {
    const [chatClient, setChatClient] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const client = new stream_chat_1.StreamChat(userInfo.apiKey, {
            enableInsights: true,
            enableWSFallback: true,
        });
        // Under some circumstances, a "connectUser" operation might be interrupted
        // (fast user switching, react strict-mode in dev). With this flag, we control
        // whether a "disconnectUser" operation has been requested before we
        // provide a new StreamChat instance to the consumers of this hook.
        let didUserConnectInterrupt = false;
        const connectUser = client
            .connectUser({
            id: userInfo.id,
            color: userInfo.color,
            role: userInfo.role,
        }, userInfo.token)
            .catch((e) => {
            console.error(`Failed to connect user`, e);
        })
            .then(() => {
            if (!didUserConnectInterrupt) {
                setChatClient(client);
            }
        });
        return () => {
            didUserConnectInterrupt = true;
            // there might be a pending "connectUser" operation, wait for it to finish
            // before executing the "disconnectUser" in order to prevent race-conditions.
            connectUser.then(() => {
                setChatClient(null);
                client.disconnectUser().catch((e) => {
                    console.error(`Failed to disconnect user`, e);
                });
            });
        };
    }, [userInfo]);
    return chatClient;
};
exports.useConnectUser = useConnectUser;
